import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { AlertType } from '@feature/alert/alert.component';
import { TypedFormGroup } from '@feature/forms/form-model';

type SnackBarData = {
  message: string;
  type: AlertType;
};

@Component({
    selector: 'wai-snack-bar',
    templateUrl: './snack-bar.component.html',
    styleUrls: ['./snack-bar.component.scss'],
    standalone: false
})
export class SnackBarComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData, public snackBarRef: MatSnackBarRef<SnackBarComponent>) {}
}
